import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const CrewMembersListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) =>
    css`
      flex-basis: 50%;
      box-shadow: 0 -3px ${theme.spacings[300]} 0 rgba(0, 0, 0, 0.16);
      background: ${theme.colors.white};
    `}
`;

export const TimeHoursHeaderStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '550' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;
export const FooterStyled = styled.div`
  justify-content: center;
  display: grid;
  grid-template-columns: 50% 50%;
`;

export const WarningContainerStyled = styled(Box).attrs({
  p: { sm: '450' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[900]};
    border-radius: ${theme.spacings[200]};
    box-shadow: 0 -3px ${theme.spacings[300]} 0 rgba(0, 0, 0, 0.16);
  `}
`;
